import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";

// Images

import SubjectBoxLayers from "../../Assets/Images/LandingPage/subjects_box_vector.svg";
import Mastering_vector from "../../Assets/Images/LandingPage/mastering_content_vector.svg";

export const MasteringContainer = styled.div`

    .mastering_section {
        background: #FFF9EB;
        padding: 100px 0;
        position: relative;
        &:after{
            position: absolute;
            content: "";
            background: url(${Mastering_vector}) no-repeat;
            width: 100%;
            height: 100%;
            bottom: 0;
            right: 0;
            background-position: top right;
            background-size: 500px;
        }
        .mygrid-container{
            z-index:1;
            position: relative;
        }
        .mastering-section-head {
            max-width: 1016px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 40px;
           
            p{
                margin-top:10px;
            }
        }
        
        .subjects_info_wrapper{
            justify-content:center;
           
        }
        .mastering-section-head {
            text-align: center;
        }
        .subjects_info-box-col{
            padding-top: 15px;
            padding-bottom: 15px;
        }
        .subjects_info-box {
            border-radius: 0 50px;
            text-align: center;
            perspective: 1000px;
            min-height: 380px; 
            height: 100%;
            cursor:pointer;
        }
        p.subtext_mastering{
            font-size: 18px;
            text-transform: uppercase;
        }
        .card-inner {
            position: relative;
            width: 100%;
            height: 100%;
            transition: transform 0.8s ease;
            transform-style: preserve-3d;
            z-index:1;
            &:after{
                position: absolute;
                content: "";
                background: url(${SubjectBoxLayers}) no-repeat;
                width: 100%;
                height: 100%;
                bottom: 0;
                right: 0;
                background-position: bottom right;
                background-size: 250px;
            }
        }

        .subjects_info-box:hover .card-inner {
            transform: rotateY(180deg);
        }

        .subjects_front,
        .subjects_back {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 0 50px;
            padding: 40px;
            backface-visibility: hidden;
            z-index:1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            overflow: hidden;
        }

        .subjects_front {
            transform: rotateY(0deg);
            z-index: 2;
        }

        .subjects_back {
            transform: rotateY(180deg);
        }

        img {
            max-width: 100px;
            max-height: 80px;
            margin-bottom: 20px;
            object-fit: contain;
        }

        h3 {
            margin-bottom: 10px;
        }
        .head_wid_icon{
            position:relative;
            &:after{

            }
        }
    }

    @media (max-width: 1199px) {
        .mastering_section {
            padding: 70px 0;
        }
        .mastering_section .subjects_front p,  .mastering_section .subjects_back p{
            font-size:18px;
        }
    }
    @media (max-width: 991px){
        .mastering_section .head_wid_icon:after{
            display:none;
        }
        .mastering_section .subjects_front,  .mastering_section .subjects_back {
            padding: 50px 30px;
        }
    }
    @media (max-width: 767px){
        .mastering_section {
            padding: 50px 0;
        }
    }

`;